<template>
  <div class="mb-4">
    <h6 class="fw-semibold mb-1">{{ question.text }}</h6>
    <p v-if="question.help_text" class="small text-muted mb-2">{{ question.help_text }}</p>

    <div v-for="c in question.choices" :key="c.id" class="form-check mb-1">
      <input
        class="form-check-input"
        :type="question.multiple ? 'checkbox' : 'radio'"
        :name="'q-' + question.id"
        :id="'q-' + question.id + '-c-' + c.id"
        :checked="isChecked(c.id)"
        @change="toggle(c.id)"
      />
      <label class="form-check-label" :for="'q-' + question.id + '-c-' + c.id">
        {{ c.text }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoteQuestion",
  model: { prop: "value", event: "input" },
  props: {
    question: { type: Object, required: true },
    value: { type: [Array, Number, String, null], default: null }, // v-model
  },
  methods: {
    isChecked(id) {
      const n = Number(id);
      if (this.question.multiple) {
        const arr = Array.isArray(this.value) ? this.value.map(Number) : [];
        return arr.includes(n);
      }
      return Number(this.value) === n;
    },
    toggle(id) {
      const n = Number(id);
      if (this.question.multiple) {
        const arr = Array.isArray(this.value) ? [...this.value.map(Number)] : [];
        const idx = arr.indexOf(n);
        if (idx >= 0) arr.splice(idx, 1); else arr.push(n);
        this.$emit("input", arr);
      } else {
        this.$emit("input", n);
      }
    },
  },
};
</script>
